import './Spinner.scss';

function Spinner() {
  return (
    <>
      <div className="spinner-cube-grid">
        <div className="spinner-cube spinner-cube1"></div>
        <div className="spinner-cube spinner-cube2"></div>
        <div className="spinner-cube spinner-cube3"></div>
        <div className="spinner-cube spinner-cube4"></div>
        <div className="spinner-cube spinner-cube5"></div>
        <div className="spinner-cube spinner-cube6"></div>
        <div className="spinner-cube spinner-cube7"></div>
        <div className="spinner-cube spinner-cube8"></div>
        <div className="spinner-cube spinner-cube9"></div>
      </div>
      <div className="spinner-message"> Please wait </div>
      <div className="spinner-bg"></div>
    </>
  );
}

export default Spinner;
